import request from "../../utils/request";

//  登录
export function login(data){
    return request({
        url: '/api/auth/login-with-code',
        method: 'post',
        data
    })
}

//  获取验证码
export function code(data) {
    return request({
        url: '/api/auth/code',
        method: 'post',
        data
    })
}
// 获取用户详情
export function getUserInfo(params) {
    return request({
        url: '/api/auth/me',
        method: 'get',
        params
    })
}
//  注销登录
export function deactivate(data,params) {
    return request({
        url: '/api/auth/deactivate?code=' + params,
        method: 'post',
        data
    })
}

//  更新用户信息
export function updateUser(data) {
    return request({
        url: '/api/auth/update-user',
        method: 'post',
        data
    })
}

//邀请记录
export function inviteRecords(params) {
    return request({
        url: '/api/auth/invite-records',
        method: 'get',
        params
    })
}